export enum BookButtonDataHooks {
  ERROR = 'booking-details-summary-CTA-error',
  ACTION_BUTTON = 'booking-details-action-button',
  SPINNER = 'booking-details-spinner',
}
